import { useState } from 'react';
import GridComponent from '../../../component/grid/GridComponent.component';
import ButtonSchedule from '../../../component/buttton/ButtonSchedule.component';
import Progress from '../../../component/progress/Progress.component';
import { useSnackbar } from '../../../context/Snackbar';
import { IFlag } from '../../store/utils/Flags';
import { ImportExport, NoteAdd } from '@material-ui/icons';
import { Container, Space } from '../styles';
import { http } from '../../../services/apiSecurity/Http.interceptor';
import { useStore } from '../../../context/Store';
import ButtonExport from '../../../component/buttton/ButtonExport';
import SelectSearch, { IOption } from '../../../component/select/SelectSearch';
import * as XLSX from 'xlsx';
import xlsx from 'json-as-xlsx';
import LoadingImportScreen from '../../../component/loadingImportScreen/LoadingImportScreen.component';

interface IExcel {
  sheet: string;
  columns: Array<{ label: string; value: any }>;
  content: Array<any>;
}

const ImportDataSecurity = () => {
  const endpointSendCsvUserStore = '/updateUserStore';
  const endpointSendCsvManagerStore = '/updateManagerStore';
  const endpointSendCsvManagerRegion = '/updateManagerRegion';
  const endpointSendCsvDirectorFlag = '/updateDirectorFlag';

  const [selectFlag, setSelectFlag] = useState<IOption>({ label: '', value: '' });
  const { setSnackbar } = useSnackbar();
  const { arrayFlags } = useStore();
  const [load, setLoad] = useState(false);
  const [processImport, setProcessImport] = useState({
    current: 0,
    total: 0,
    errors: 0,
    seconds: 0,
  });

  const processXLSX = async (event: any, endpoint: string) => {
    setLoad(true);
    event.preventDefault();

    if (event.target.files[0]) {
      const files: any = event.target.files,
        f = files[0];
      const reader = new FileReader();

      reader.onload = function (e: any) {
        var data = e.target.result;
        let readedData = XLSX.read(data, { type: 'binary' });
        const wsname = readedData.SheetNames[0];
        const ws = readedData.Sheets[wsname];

        /* Convert array to json*/
        const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
        if (dataParse.length > 1) {
          const headers = dataParse.shift();
          importData(endpoint, dataParse, headers);
        } else {
          setSnackbar({
            type: 'error',
            msg: 'Erro ao enviar os dados!',
            subMsg: 'Nenhum dado foi informado.',
          });
        }
      };
      reader.readAsBinaryString(f);
    }
    setLoad(false);
  };

  const splitter = (arr: any[], maxLength = 30) => {
    const res: any[] = [];
    for (let i = 0; i < arr.length; i += maxLength) {
      const chunk: any[] = arr.slice(i, i + maxLength);
      res.push(chunk);
    }
    return res;
  };

  const importData = async (endpoint: string, dataParse: any[], headers: any) => {
    const maxLength = 30;
    let curr = 0;
    let errorsCount = 0;
    const arrError: any[] = [];
    let seconds = 0;

    let arrSplitted = splitter(dataParse, maxLength);

    for (const arr of arrSplitted) {
      const before = new Date();

      curr = curr + arr.length;
      setProcessImport({
        seconds: seconds,
        errors: errorsCount,
        total: dataParse.length,
        current: curr,
      });
      await http
        .put(endpoint, { data: arr, headers: headers })
        // eslint-disable-next-line no-loop-func
        .catch((err) => {
          errorsCount = errorsCount + arr.length;
          setProcessImport({ ...processImport, errors: errorsCount });
          console.log('ERRO AO ENVIAR DADOS: ', err);

          let newObj: any = {};

          headers.forEach((v: any, i: number) => {
            newObj[v] = arr[i];
          });

          arrError.push(newObj);
        });

      const after = new Date();
      seconds = Math.abs(after.getTime() - before.getTime()) / 1000 / arr.length;
      setProcessImport({ ...processImport, seconds: seconds });
    }
    setProcessImport({ current: 0, total: 0, errors: 0, seconds: 0 });

    if (arrError.length > 0) {
      setSnackbar({
        type: 'error',
        msg: 'Erro ao enviar os dados!',
        subMsg: 'Houve erro ao enviar alguns dados!',
      });
      let data: IExcel[] = [
        {
          sheet: 'dados-com-erro'.toUpperCase(),
          columns: [],
          content: arrError,
        },
      ];

      headers.forEach((r: string) => {
        data[0].columns.push({
          label: r,
          value: r,
        });
      });

      let settings = {
        fileName: `dados-com-erro`,
      };
      console.log(data);
      xlsx(data, settings);
    } else {
      setSnackbar({
        type: 'success',
        msg: 'Dados enviados',
        subMsg: 'Abra a fila de processamento para iniciar',
      });
    }
  };

  // SEND REQUEST FOR XSLX TEST AND SEND RESPONSE WITH FILE
  const downloadXLSX = async (url: string, filename: string) => {
    try {
      setLoad(true);
      await http
        .get(url)
        .then((response) => {
          if (response.data.length > 0) {
            let headers: string[] = Object.keys(response.data[0]);

            let data: IExcel[] = [
              {
                sheet: filename.toUpperCase(),
                columns: [],
                content: response.data,
              },
            ];

            headers.forEach((r) => {
              data[0].columns.push({
                label: r,
                value: r,
              });
            });

            let settings = {
              fileName: `base-${filename}`,
            };
            xlsx(data, settings);
          }
        })
        .catch((err) => {
          console.log(`Error when get api data for export: ${filename}`, err);
          setSnackbar({
            type: 'error',
            msg: 'Erro ao exportar os dados!',
            subMsg: 'Verificar o log para mais informação',
          });
        })
        .finally(() => setLoad(false));
    } catch (err) {
      setLoad(false);
      setSnackbar({
        type: 'error',
        msg: 'Erro ao coletar os dados!',
        subMsg: 'Verificar o log para mais informação',
      });
      console.log(`Error when format data for export: ${filename}`, err);
    }
  };

  const getUserStore = async () => {
    await downloadXLSX(`/getCSVUserStore?flag_id=${selectFlag.value}`, 'usuario_loja_principal');
  };

  const getManagerStore = async () => {
    await downloadXLSX(`/getCSVManagerStore?flag_id=${selectFlag.value}`, 'gerente_de_loja');
  };

  const getManagerRegion = async () => {
    await downloadXLSX(`/getCSVManagerRegion?flag_id=${selectFlag.value}`, 'gerente_regional');
  };

  const getDiretorFlag = async () => {
    await downloadXLSX(`/getCSVDirectorFlag`, 'diretor_bandeira');
  };

  const formatArrayFlags = (): IOption[] => {
    const flagsOptions: IOption[] = [];

    arrayFlags.forEach((a: IFlag) => {
      flagsOptions.push({ label: String(a.flag), value: a.id });
    });

    return flagsOptions;
  };

  const handleChangeFlag = (selectOption: IOption) => {
    setSelectFlag(selectOption || { label: '', value: '' });
  };

  return (
    <>
      <LoadingImportScreen
        latency={processImport.seconds}
        total={processImport.total}
        current={processImport.current}
        errors={processImport.errors}
      />

      <GridComponent justify='space-between' alignItems='center'>
        <SelectSearch
          title='Bandeira'
          data={formatArrayFlags()}
          onChange={(event: any, selectOption: any) => handleChangeFlag(selectOption)}
          placeholder='Selecione...'
          value={selectFlag}
          request={load}
          sm={12}
          md={6}
          lg={3}
        />
      </GridComponent>

      {load ? (
        <Progress open={load} />
      ) : (
        <>
          <GridComponent direction='row' alignItems='flex-start' margin='0 0 20px 0'>
            {/* USUARIO / LOJA */}
            <Container style={{ maxWidth: '180px', marginTop: '30px', paddingTop: '15px' }}>
              <span className='title'>Usuário Loja Principal</span>
              <ButtonExport
                onClick={() => (selectFlag.value === '' ? false : getUserStore())}
                htmlFor='userStoreBase'
                disable={selectFlag.value === '' ? true : false}
                icon={<ImportExport fontSize='large' />}
                label='Extrair Base'
              />
              <ButtonSchedule
                icon={<NoteAdd fontSize='large' />}
                label='Carregar'
                onClick={(e) => processXLSX(e, endpointSendCsvUserStore)}
                htmlFor='userStoreCaregar'
                type='upload-excel'
                disable={false}
              />
            </Container>

            {/* Gerente de Loja */}
            <Space margin='20px' />
            <Container style={{ maxWidth: '180px', marginTop: '30px', paddingTop: '15px' }}>
              <span className='title'>Gerente de Loja</span>
              <ButtonExport
                onClick={() => (selectFlag.value === '' ? false : getManagerStore())}
                htmlFor='managerStore'
                disable={selectFlag.value === '' ? true : false}
                icon={<ImportExport fontSize='large' />}
                label='Extrair Base'
              />
              <ButtonSchedule
                icon={<NoteAdd fontSize='large' />}
                label='Carregar'
                onClick={(e) => processXLSX(e, endpointSendCsvManagerStore)}
                htmlFor='managerStoreCaregar'
                type='upload-excel'
                disable={false}
              />
            </Container>

            {/* Gerente Regional */}
            <Space margin='20px' />
            <Container style={{ maxWidth: '180px', marginTop: '30px', paddingTop: '15px' }}>
              <span className='title'>Gerente Regional</span>
              <ButtonExport
                onClick={() => (selectFlag.value === '' ? false : getManagerRegion())}
                htmlFor='managerRegion'
                disable={selectFlag.value === '' ? true : false}
                icon={<ImportExport fontSize='large' />}
                label='Extrair Base'
              />
              <ButtonSchedule
                icon={<NoteAdd fontSize='large' />}
                label='Carregar'
                onClick={(e) => processXLSX(e, endpointSendCsvManagerRegion)}
                htmlFor='managerRegionCaregar'
                type='upload-excel'
                disable={false}
              />
            </Container>

            {/* Diretor de Bandeira */}
            <Space margin='20px' />
            <Container style={{ maxWidth: '180px', marginTop: '30px', paddingTop: '15px' }}>
              <span className='title'>Diretor de Bandeira</span>
              <ButtonExport
                onClick={() => getDiretorFlag()}
                htmlFor='directoreFlagBase'
                disable={false}
                icon={<ImportExport fontSize='large' />}
                label='Extrair Base'
              />
              <ButtonSchedule
                icon={<NoteAdd fontSize='large' />}
                label='Carregar'
                onClick={(e) => processXLSX(e, endpointSendCsvDirectorFlag)}
                htmlFor='directoreFlagCaregar'
                type='upload-excel'
                disable={false}
              />
            </Container>
          </GridComponent>
        </>
      )}
    </>
  );
};

export default ImportDataSecurity;
